module.exports = __webpack_public_path__ + "index_pc/img/b1.29824d18.png";